<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M13.4 7.6v12.6q0 .7-.5 1.2t-1 .4-1.2-.4-.5-1.2V7.6L5 12.8q-.5.5-1.1.5t-1.1-.5-.5-1.1.5-1.2l7.9-7.9 1.1-.4 1.1.4 8 8q.4.4.4 1 0 .8-.4 1.2-.5.5-1.2.5t-1.1-.5z"
    />
  </svg>
</template>
